<template>
  <CCard>
    <CCardHeader>
      <CRow>
        <CCol col="8" style="text-align: start">


          <strong>{{ $t('cashListDocsPay') }}</strong>

        </CCol>
      </CRow>
      <!--        </div>-->

      <!-- Right aligned nav items -->
      <!--      </CCollapse>-->
    </CCardHeader>
    <CRow>
      <CCol col="3">
        <date-picker
            :label="$t('components.startDate')"
            v-model="start_date"></date-picker>
      </CCol>
      <CCol col="3">
        <date-picker
            :label="$t('components.endDate')"
            v-model="end_date"></date-picker>

      </CCol>
      <CCol col="3">
        <CSelect
                :options="cashiers"
                :value.sync="selected_cashier"
        />

      </CCol>
      <CCol col="1">

        <CButton @click="get_receive_list()" color="dark"
                 size="sm">
          <CIcon size="sm" name="cil-zoom"/>
        </CButton>
      </CCol>
    </CRow>
          <CDataTableFixed
              :items="items_filtered"
              :fields="fields"
              striped
              border
height="300px"
              @row-clicked="table_row_clicked"

              sorter
              column-filter
              :items-per-page="200"
              hover
              pagination
          >


            <template #row="{item,index}">

              <td style="text-align: center">
                <p style="text-align: center">{{ index + 1 }}</p>

              </td>

            </template>

            <template #docNo="{item}">
              <td>
                <p style="text-align: center" >
                  <a :href="'/dashboard/accounting/show-accounting-doc/'+item.docNoId" target="_blank">
                    {{ item.docNo }}
                  </a>
                </p>
              </td>
            </template>
            <template #docDate="{item}">
              <td>
                <p style="text-align: center">{{ get_date(item.docDate) }}</p>
              </td>
            </template>
            <template #cashPaymentCode="{item}">
              <td>
                <p style="text-align: center" v-c-tooltip="item.payDesc ? {
        content: item.payDesc,
        placement: 'bottom-start'
      } : ''">{{ (item.cashPaymentCode) }}</p>
              </td>
            </template>
            <template #recCode="{item}">
              <td>
                <p style="text-align: center">{{ (item.recCode) }}</p>
              </td>
            </template>
            <template #masterCode="{item}">
              <td>
                <p style="text-align: center">{{ (item.masterCode) }}</p>
              </td>
            </template>
            <template #amount="{item}">
              <td>
                <p style="float: right">{{ get_currency(parseFloat(Math.abs(item.amount))) }}</p>
              </td>
            </template>
            <template #payDesc="{item}">

              <td>
                <p v-if="item.payDesc!=null">{{ item.payDesc }}</p>

              </td>

            </template>

            <template #under-table="{item}">
              <CRow>

                <CCol>

                </CCol>
                <CCol>

                </CCol>
                <CCol>

                </CCol>
                <CCol>

                </CCol>
                <CCol>
                  {{ $t('totalSum') }} :{{ get_currency(Math.abs(calculate_items(items_filtered, "amount"))) }}
                </CCol>
                <CCol>

                </CCol>
              </CRow>
            </template>


          </CDataTableFixed>

    <CModal
        :show.sync="show_factor_detail"
        :no-close-on-backdrop="true"
        :centered="true"
        :title="$t('InventoryBill')"
        size="lg"
        color="dark"
    >
      <CCard id="printMe">
        <ShowPayReceiveDocs :doc_id="selected_doc_id"/>

      </CCard>


      <template #footer>

        <CButton
            @click="show_factor_detail = false"
            color="success"
        >{{ $t("buttons.close") }}
        </CButton>
      </template>
    </CModal>


  </CCard>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import moment from 'moment-jalaali'
import BTabs from "../../tabs/BTabs";
import AddPayCash from "./AddPayCash";
import AddPayCheque from "./AddPayCheque";
import PayingOrders from "./PayingOrders";
import ShowPayReceiveDocs from "../accounting/ShowPayReceiveDocs";

var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }
export default {
  name: 'PayOperation',
  components: {
    Treeselect,
    BTabs,
    AddPayCash,
    AddPayCheque,
    PayingOrders,
    ShowPayReceiveDocs,

  },

  data() {
    return {
      show_factor_detail:false,
          selected_doc_id:null,
        table_clicks_timer:null,
        table_clicks:0,
      start_date: '',
      end_date: '',
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      master_id: null,
       master_types: [{id: '1', label: this.$t('factor')}, {id: '2', label: this.$t('debtors')}, {id: '3', label: this.$t('persons')}],
      active_tab: 0,
      search_reference_master: 0,

      date_cash: '',
      date_cheque: '',
      summary: '',
      cashiers: [],
      selected_cashier:0,

      banks: [],
      terminals: [],
      selected_payer: 0,
      selected_receiver_cash: null,
      selected_receiver_cheque: null,
      doc_types: [
        {value: 2, label: this.$t('components.cash')},
        {
          value: 6, label: this.$t('components.bank')
        }, {value: 1, label: this.$t('components.pos')}],
      selected_doc_type: 2,
      status_form: 0,
      price: '',

      items_accounting_groups: [],
      selected_accounting_group: null,
      items_accounting_sub_groups: [],
      selected_accounting_sub_group: null,
      items_accounting_data: [],

      items_pay_cash: [{}],

      items_pay_cheque: [{}],

      searched_person: [],
      document_person: null,
      document_person_cheque: null,
      search_user_async: true,

      fields2: [
        {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:3%;padding:0px'},
        {key: 'docDate', label: this.$t('tables.payDate'), _style: 'padding:0px'},
        {key: 'partyName', label: this.$t('tables.customer'), _style: 'padding:0px'},
        {key: 'amount', label: this.$t('tables.amount'), _style: 'padding:0px'},

        {key: 'cashierName', label: this.$t('tables.payer'), _style: 'padding:0px'},
        {key: 'payerName', label: this.$t('tables.payType'), _style: 'padding:0px'},
        {key: 'summary', label: this.$t('tables.summary'), _style: 'padding:0px'},
      ],
      fields: [
        {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:3%;padding:0px'},
        {key: 'docDate', label: this.$t('date'), _style: 'padding:0px'},

        {key: 'cashPaymentCode', label: this.$t('payCode'), _style: 'padding:0px'},
        {key: 'docNo', label: this.$t('docNumber'), _style: 'padding:0px'},
        {key: 'partyName', label: this.$t('tables.customer'), _style: 'padding:0px'},
        {key: 'masterCode', label: this.$t('reference'), _style: 'padding:0px'},

        {key: 'amount', label: this.$t('tables.amount'), _style: 'padding:0px'},

        {key: 'cashierName', label: this.$t('tables.bankAccTitle'), _style: 'padding:0px'},
        {key: 'payerName', label: this.$t('payer'), _style: 'padding:0px'},
        // {key: 'paymentTypeTitle', label: this.$t('tables.payType'), _style: 'padding:0px'},
        // {key: 'payDesc', label: this.$t('description'), _style: 'padding:0px'},
      ],
      items: [],
      items_filtered:[],


      get_items: [1],
      cheque_banks:[],
    }
  }, mounted() {
    this.date_cash =this.get_today();
    this.date_cheque = this.get_today();

    this.start_date = this.get_day_before_today(1);
    this.end_date = this.get_today();

    // this.$root.root_validate_errors = [];
// this.$root.header_action.innerHTML = this.$refs['action_bar'].innerHTML
//     this.get_banks();
    this.get_cashiers();
    // this.get_terminals();
    this.get_lists_groups();
    this.get_receive_list();
    var self = this
    bus.$on("update_add_pay", (data) => {
      // alert(data);
      this.get_receive_list();

    });

    if (this.$route.params.product_id != null) {
      this.editable = true;
      this.status_form = this.$route.params.product_id;
      this.get_product_data();
    }
  }, watch: {
    '$route.params.product_id': function () {
      this.get_product_data();
    },
    'selected_accounting_group': function () {
      this.get_lists_sub_groups();
    },
    'start_date': function () {
      this.get_receive_list();
    },
    'end_date': function () {
      this.get_receive_list();
    },
    'selected_cashier': function () {
      if(this.selected_cashier==0){
        this.items_filtered = this.items;
      }else{
        this.items_filtered = this.items.filter(x=>x.cashierId==this.selected_cashier)
      }
    }
  },
  computed: {

  },
  methods: {
    table_row_clicked(item, index) {
      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        console.log("clicked")

        this.table_clicks = 0
        this.show_factor_detail=true
        this.selected_doc_id=item.recId
      }

    },

    get_receive_list() {
      var self = this;

      const formData = new FormData();


      formData.append('FromDate', this.start_date);
      formData.append('ToDate', this.end_date);


      axios.post('GetCashPaymentList', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          content_data.data.reverse()
          content_data.data.forEach(function (val){
            if(val.payDesc==null){
              val.payDesc = " "
            }
          })
          console.log("data received",content_data.data)
          self.items = content_data.data.filter(item => parseFloat(item.amount) < 0);

          self.items = self.items.map((item, row_id) => {
            return {...item, row_id}
          });
          self.items_filtered = self.items
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
              .catch(function (error) {

                console.log(error);
              });

    },

    get_banks() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);

      axios.post('GetBankAccounts', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.cashiers= self.sort_array(self.cashiers,
          //     content_data.data,
          //     'id','bankAccTitle')
          self.get_terminals()
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
              .catch(function (error) {

                console.log(error);
              });

    },
    get_cashiers() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);
      self.cashiers=[{label: this.$t('all'), value: 0}]

      axios.post('GetCashierTitles', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.cashiers=self.sort_array(self.cashiers,
                  content_data.data.filter(x => x.accountId == 70),
                  'id','boxTitle');

          self.get_terminals()


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
              .catch(function (error) {

                console.log(error);
              });

    },
    get_terminals() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetBankTerminals', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.cashiers= self.sort_array(self.cashiers,
                  content_data.data,
                  'id','terminalTitle')
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
              .catch(function (error) {

                console.log(error);
              });

    },
    get_lists_groups() {
      var self = this;
      self.items_accounting_groups = [];
      // GetChequeInfo
      // FirstDate
      // SecondDate
      // MasterId => 0 biad ya por bede
      const formData = new FormData();
      var url = "Get_AllAccountingGroups";

      // formData.append("id", 1);

      axios.post(url, formData, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {


              self.items_accounting_data = response.data.data.map((item, row_id) => {
                return {...item, row_id}
              })

              var obj2 = {
                label: "All",
                id: 0,
              }
              self.items_accounting_groups.push(obj2)

              // console.log(self.data);
              response.data.data.forEach((val) => {
                if (val.parentId == 0) {

                  self.get_childrens_one_sub(val.id, self.items_accounting_data).forEach((val2) => {

                    self.get_childrens_one_sub(val2.id, self.items_accounting_data).forEach((val3) => {
                      var obj2 = {
                        label: val3.accountName,
                        code: val3.accountCode,
                        id: val3.id,
                      }

                      self.items_accounting_groups.push(obj2)

                    });
                  });

                }

              });
              // self.filter_data();

            } else {
              self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

            }

          }
      )
          .catch(function (error) {
            console.log(error);
          });

    },
    get_lists_sub_groups() {
      var self = this;
      this.items_accounting_sub_groups = []
      this.selected_accounting_sub_group = null


      self.get_childrens_one_sub(this.selected_accounting_group, self.items_accounting_data).forEach((val2) => {
        var obj2 = {
          label: val2.accountName,
          code: val2.accountCode,
          id: val2.id,
        }
        self.items_accounting_sub_groups.push(obj2)

      });


    },
    get_childrens_one_sub(parent_id, list) {
      var array = [];
      list.forEach((val2) => {

        if (parent_id == val2.parentId) {
          // var obj = {label: val2.accountCode + " " + val2.accountName, value: val2.id, code: val2.accountCode}
          array.push(val2);


        }
      });
      return array;
    },


  }
}

</script>
